import { Flex, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { BiFilter } from 'react-icons/bi';

import EditPencilIcon from 'components/Icons/EditPencilIcon';
import { DriverPanelBarsFilterIcon } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/icons/DriverPanelFigmaIcons';
import { usePlanRevampTable } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/PlanRevampTableContext';

const HeaderComponent = ({ cell }: any) => {
  const [hoverHeaderCell, setHoverHeaderCell] = useState(false);
  const isRevampTable = usePlanRevampTable();

  const handleHover = (status: boolean) => {
    if (cell?.hasFilters) {
      setHoverHeaderCell(status);
    }
  };

  const showFilter = isRevampTable ? cell?.hasFilter : cell?.hasFilter && hoverHeaderCell;

  return (
    <>
      {cell?.text === 'Del' ? (
        isRevampTable ? (
          <p style={{ margin: 0, textAlign: 'center', width: '100%' }}>Action</p>
        ) : (
          <EditPencilIcon />
        )
      ) : (
        <Flex
          width='100%'
          height='inherit'
          justifyContent='space-between'
          alignItems='center'
          gap={isRevampTable ? '10px' : undefined}
          onMouseOver={() => {
            if (cell?.hasFilters) handleHover(true);
          }}
          onMouseLeave={() => {
            if (cell?.hasFilters) handleHover(false);
          }}
        >
          <Tooltip label={cell.text}>
            <p
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                maxWidth: '100%',
                textOverflow: 'ellipsis',
                margin: 0,
              }}
            >
              {cell.text}
            </p>
          </Tooltip>
          {showFilter &&
            (isRevampTable ? (
              <DriverPanelBarsFilterIcon />
            ) : (
              <span className='rg-legacy-filter-icon'>
                <BiFilter size={30} color='rgb(190 218 218)' />
              </span>
            ))}
        </Flex>
      )}
    </>
  );
};

export default HeaderComponent;
